/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "禁止收集平台主播商家手机号",
        type: "tips"
    },
    {
        name: "表单",
        type: "module-name"
    },
    {
        key: "link_data",
        name: "表单",
        type: "form"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "button_name",
                name: "按钮文案",
                type: "text",
                memo: "按钮最多10个字",
                max: 10
            },
            {
                key: "success_text",
                name: "成功提示文案",
                type: "text",
                memo: "成功提示文案最多30个字",
                max: 30
            },
            {
                key: "button_color",
                name: "按钮颜色",
                type: "color"
            },
            {
                key: "font_color",
                name: "字体颜色",
                type: "color"
            },
            {
                key: "show_fix",
                name: "是否悬浮",
                type: "radio-box",
                "radio-list": [{
                        label: "页面内",
                        value: 1
                    },
                    {
                        label: "悬浮",
                        value: 2
                    }
                ]
            }
        ]
    }
];
export default config;